import { Fragment, useCallback } from 'react'
import { Transition } from '@headlessui/react'
import { getTransitionClasses } from '@/molecules/utils'
import { ReactFCC } from '@/types/react'
import { useSafeTrack } from '@/utils/analytics'

export interface FeaturePromptProps {
  show: boolean
  featureName?: string
  onClick?: () => void
  promptName?: string
}

export const FeaturePrompt: ReactFCC<FeaturePromptProps> = ({ children, featureName, onClick, promptName, show }) => {
  const track = useSafeTrack()

  const handleClick = useCallback(() => {
    onClick?.()
    track('Feature Prompt Clicked', {
      featureName,
      promptName,
    })
  }, [featureName, onClick, promptName, track])

  return (
    <Transition as={Fragment} show={show} {...getTransitionClasses('from-right')}>
      <div onClick={handleClick} className="mr-10 flex cursor-pointer items-center">
        {children}
      </div>
    </Transition>
  )
}
